import { Bold } from "@faire/web/ui/Typography/Span";
import React from "react";
export var BoldFormatting = function BoldFormatting(chunk) {
  return /*#__PURE__*/React.createElement(Bold, null, chunk);
};